module.exports = __webpack_public_path__ + "static/media/Sentiment_Logo_White.bb55f602.png";